<template>
    <div class="pageClass VideoClass">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <NavBar></NavBar>
        <h3 class="m-2">{{CourseName}}</h3>

        <!-- 影片區 -->
        <!--<img src="" />-->
        <WatchVideo :VideoItem="VideoItem"></WatchVideo>
        <div class="d-flex  justify-content-start m-2">
            <!-- 總覽 -->
            <VideoOverview class="VideoOverview" :CourseId="CourseId"></VideoOverview>
            <!-- 影片清單 -->
            <VideoList class="VideoList" :CourseMaterial="CourseMaterial"></VideoList>
        
        </div>
        
    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import WatchVideo from '@/components/VideoPage/WatchVideo'
import VideoList from '@/components/VideoPage/VideoList'
import VideoOverview from '@/components/VideoPage/VideoOverview'
import axios from 'axios'
import moment from 'moment'
import {app} from '@/main'

export default {
    name: 'VideoClassPage',
    components:{
        NavBar,
        WatchVideo,
        VideoList,
        VideoOverview
    },
    data () {
        return {
            loginInputData:{
                Token :'',
                CustomerCode:'',
                StudentId:''
            },
            showLoading:false,
            CourseId:0,
            CourseName:'初階商用英文',
            CourseMaterial:[],
            VideoItem:{},
            MaterialUnitId:0,
            MaterialCode:'',
        }
    },

    methods:{
        SetChangVideoItem(VideoItem,type,MaterialUnitId){
            this.VideoItem = VideoItem;
            if(MaterialUnitId != undefined){
                this.MaterialUnitId = MaterialUnitId;
            }
            
            this.CourseMaterial.forEach((CourseMaterial,CMIndex) => {
                CourseMaterial.Material.forEach((Material,MIndex) => {
                    Material.Video.forEach((Vitem,index)=>{
                        if(Vitem.MaterialUnitVideoId == VideoItem.MaterialUnitVideoId){
                            switch (type) {
                                case 'changeVideo':
                                    Vitem.playing=true;
                                    return;
                                case 'LastendTime':
                                    Vitem.LastendTime = VideoItem.LastendTime;
                                    return;
                            }
                        }else{
                            Vitem.playing=false;
                        }
                    })
                })
            })
            this.spliceItem = this.CourseMaterial[0];
            this.CourseMaterial.splice(0, 1, this.spliceItem);
        },

        // NextVideo(){
        //     var CMIndex = 0;
        //     var MIndex = 0;
        //     var VideoIndex = 0;

        //     this.CourseMaterial.forEach((CourseMaterial,CourseMaterialIndex) => {
        //         CourseMaterial.Material.forEach((Material,MaterialIndex) => {
        //             if(Material.Video.findIndex(item=> item.MaterialUnitVideoId === this.VideoItem.MaterialUnitVideoId) != -1){
        //                 CMIndex = CourseMaterialIndex;
        //                 MIndex = MaterialIndex;
        //                 VideoIndex = Material.Video.findIndex(item=> item.MaterialUnitVideoId === this.VideoItem.MaterialUnitVideoId);
        //             }
        //         })
        //     })

        //     //下一支Video
        //     if(this.CourseMaterial[CMIndex].Material[MIndex].Video.length > (VideoIndex+1)){
        //         this.VideoItem = this.CourseMaterial[CMIndex].Material[MIndex].Video[VideoIndex+1];
        //     }else{
        //         if(this.CourseMaterial[CMIndex].Material.length > (MIndex+1)){
        //             if(this.CourseMaterial[CMIndex].Material[MIndex+1].Video.length > 0){
        //                 this.VideoItem = this.CourseMaterial[CMIndex].Material[MIndex+1].Video[0];
        //             }
        //         }else if(this.CourseMaterial.length > (CMIndex+1)){
        //             if(this.CourseMaterial[CMIndex+1].Material.length > 0){
        //                 if(this.CourseMaterial[CMIndex+1].Material[0].Video.length > 0){
        //                     this.VideoItem = this.CourseMaterial[CMIndex+1].Material[0].Video[0];
        //                 }
        //             }
        //         }
        //     }
        //     // console.log(this.VideoItem)
        // },
        //取得課程所有教材 - 依課程id (含單元&影片
        GetVideoClassDetailByStudentId(){
            this.showLoading = true;
            const api =`${process.env.VIDEOAPIPATH}/api/Material/GetVideoClassDetailByStudentId`;
            const headers = {"Authorization": 'Bearer '+this.loginInputData.Token};
            const inputdata = 
            {
                "LessonPlanId": this.$route.params.CourseItem.LessonPlanId,
                "StudentId": this.loginInputData.StudentId ,
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    var LateModifiedDate = '';
                    var CourseMaterialIndex = 0;
                    var MaterialIndex = 0;
                    var VideoIndex = 0;

                    var CurrentlyFlag = false; //檢查是不是第一次進來
                    this.CourseId = response.data.CourseId;
                    this.CourseName = response.data.CourseName;
                    this.CourseMaterial = response.data.CourseMaterial;
                    this.CourseMaterial.forEach((CourseMaterial,CMIndex) => {
                        CourseMaterial.Material.forEach((Material,MIndex) => {
                            Material.Video.forEach((item,VIndex)=>{
                                if(item.CurrentlyFlag){
                                    // debugger;
                                    CurrentlyFlag = true;
                                    if(LateModifiedDate == ''){
                                        LateModifiedDate = item.ModifiedDate;
                                        this.VideoItem = item;
                                        this.MaterialUnitId = Material.MaterialUnitId;
                                        this.MaterialCode = CourseMaterial.MaterialCode;
                                        CourseMaterialIndex = CMIndex;
                                        MaterialIndex = MIndex;
                                        VideoIndex = VIndex;
                                    }else{
                                        if((item.ModifiedDate) > (LateModifiedDate)){
                                            LateModifiedDate = item.ModifiedDate;
                                            this.VideoItem = item;
                                            this.MaterialUnitId = Material.MaterialUnitId;
                                            this.MaterialCode = CourseMaterial.MaterialCode;
                                            CourseMaterialIndex = CMIndex;
                                            MaterialIndex = MIndex;
                                            VideoIndex = VIndex;
                                        }
                                    }
                                }
                            });
                        });
                    });
                    if(!CurrentlyFlag){
                        if(this.CourseMaterial.length > 0){
                            if(this.CourseMaterial[0].Material.length > 0){
                                if(this.CourseMaterial[0].Material[0].Video.length > 0){
                                    this.VideoItem = this.CourseMaterial[0].Material[0].Video[0];
                                    this.MaterialUnitId = this.CourseMaterial[0].Material[0].MaterialUnitId;
                                    this.MaterialCode = this.CourseMaterial[0].MaterialCode;
                                    this.CourseMaterial[0].Material[0].Video[0].playing = true;
                                }
                            }
                        }
                    }else{
                        this.CourseMaterial[CourseMaterialIndex].Material[MaterialIndex].Video[VideoIndex].playing = true;
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("取得課程失敗："+ error.message);
                });
        },
        //開通HiQuiz試券(依教材及單元) 
        //每次播放都丟此API
        ActivateMaterialUnitByMaterialUnitId(){
            this.showLoading = true;
            const api =`${process.env.VIDEOAPIPATH}/api/Quiz/ActivateMaterialUnitByMaterialUnitId`;
            const headers = {"Authorization": 'Bearer '+this.loginInputData.Token};
            const inputdata = 
            {
                // "MaterialCode": this.MaterialCode,
                "MaterialUnitId":this.MaterialUnitId,
                "StudentId": parseFloat(this.loginInputData.StudentId) ,
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.IsSuccess){

                    }else{

                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
    },    
    created(){
        this.$root.$refs.VideoClassPage = this;
        this.loginInputData.Token = sessionStorage.getItem('Token');
        this.loginInputData.StudentId = sessionStorage.getItem('StudentId');

        if(this.$route.params.CourseItem == undefined){
            this.$route.params.CourseItem = JSON.parse(localStorage.getItem('CourseItem'));
        }

        this.GetVideoClassDetailByStudentId();

        window.addEventListener('beforeunload',()=>{
            var CourseItem = JSON.stringify(this.$route.params.CourseItem);
            localStorage.setItem('CourseItem', CourseItem);
        })
    },
    
    beforeDestroy() {
        window.removeEventListener('beforeunload', () => {
            // console.log('remove refresh');
            return null
        })
    },
    changeLang(lang){
    app.$i18n.locale=lang
    },
}
</script>





// WEBPACK FOOTER //
// src/components/pages/VideoClassPage.vue